import { render } from "./DeleteFileModal.vue?vue&type=template&id=24c9f1ea"
import script from "./DeleteFileModal.vue?vue&type=script&lang=js"
export * from "./DeleteFileModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__